/**
 * DKY - Tombol hati (like publik + wishlist)
 * ==========================================
 *
 * Cara pakai di Liquid:
 *   <dky-like data-handle="{{ product.handle }}"></dky-like>
 *   <dky-like data-handle="{{ product.handle }}" data-compact></dky-like>   (untuk kartu produk)
 *
 * ATURAN (keputusan Nandha, 25 Agu 2026):
 *   - Klik hati       -> angka like naik 1 DAN produk masuk wishlist.
 *   - Klik hati lagi  -> angka like turun 1. Wishlist TIDAK ikut terhapus.
 *   - Hapus dari halaman wishlist -> angka like TIDAK berubah sama sekali.
 *   Jadi hati terisi = "saya sudah like", bukan "ada di wishlist saya".
 *
 * Angka like disimpan di Cloudflare Worker (dokoyo-likes). Wishlist disimpan
 * di browser, dan ikut tersimpan di server kalau pembeli login akun Shopify
 * supaya daftarnya ikut pindah antar HP.
 */

(function () {
  const API = 'https://dokoyo-likes.dokoyoapps.workers.dev';
  const KEY_VISITOR = 'dky_visitor';
  const KEY_WISHLIST = 'dky_wishlist';

  /* ---------- penyimpanan di browser ---------- */

  function safeGet(key) {
    try {
      return localStorage.getItem(key);
    } catch (error) {
      return null; // Mode penyamaran / cookie diblokir.
    }
  }

  function safeSet(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch (error) {
      /* diamkan - fitur tetap jalan untuk satu kunjungan saja */
    }
  }

  /** Tanda pengenal acak per browser. Bukan data pribadi, cuma angka acak. */
  function visitorId() {
    let id = safeGet(KEY_VISITOR);
    if (!id) {
      id = 'v-' + (crypto.randomUUID ? crypto.randomUUID() : Date.now() + '-' + Math.random().toString(36).slice(2));
      safeSet(KEY_VISITOR, id);
    }
    return id;
  }

  function customerId() {
    return window.DKY_CUSTOMER_ID || null;
  }

  function getWishlist() {
    try {
      const list = JSON.parse(safeGet(KEY_WISHLIST) || '[]');
      return Array.isArray(list) ? list : [];
    } catch (error) {
      return [];
    }
  }

  /**
   * `rinci` berisi { handle, action } untuk aksi yang datang dari tombol hati.
   * Penyelarasan dari server saat halaman dimuat sengaja TIDAK mengisinya,
   * supaya pendengar di luar bisa membedakan "orang menekan tombol" dari
   * "daftar baru saja disamakan dengan server" - yang kedua tidak boleh
   * memunculkan animasi atau notifikasi apa pun.
   */
  function setWishlist(list, rinci) {
    safeSet(KEY_WISHLIST, JSON.stringify(list));
    const detail = { handles: list };
    if (rinci) {
      detail.handle = rinci.handle;
      detail.action = rinci.action;
    }
    document.dispatchEvent(new CustomEvent('dky:wishlist-change', { detail: detail }));
  }

  function addToWishlist(handle) {
    const list = getWishlist();
    /* Kalau handle-nya sudah ada, daftarnya memang tidak berubah - tapi
       kabarnya tetap dikirim. Status hati datang dari server sementara daftar
       ini dari localStorage, jadi keduanya bisa tidak sinkron pada pengunjung
       lama; tanpa kabar itu, me-love ulang tidak memunculkan apa-apa. */
    if (!list.includes(handle)) list.unshift(handle);
    setWishlist(list, { handle: handle, action: 'add' });

    const customer = customerId();
    if (customer) {
      post('/wishlist', { customer: customer, add: [handle] }).catch(() => {});
    }
  }

  function removeFromWishlist(handle) {
    const list = getWishlist().filter((item) => item !== handle);
    setWishlist(list, { handle: handle, action: 'remove' });

    const customer = customerId();
    if (customer) {
      post('/wishlist', { customer: customer, remove: [handle] }).catch(() => {});
    }
  }

  /* ---------- panggilan ke server ---------- */

  function post(path, body) {
    return fetch(API + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }).then((response) => (response.ok ? response.json() : Promise.reject(response.status)));
  }

  /**
   * Menyamakan wishlist di browser dengan wishlist di server.
   * Dijalankan sekali saat halaman dibuka, hanya kalau pembeli login.
   * Yang ada di browser tapi belum di server akan diunggah, lalu hasil
   * gabungannya dipakai bersama.
   */
  function syncWishlist() {
    const customer = customerId();
    if (!customer) return;

    post('/wishlist', { customer: customer, add: getWishlist() })
      .then((data) => {
        if (data && Array.isArray(data.handles)) setWishlist(data.handles);
      })
      .catch(() => {});
  }

  /* ---------- komponen hati ---------- */

  const HEART = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20.7 3.9 12.6a5.1 5.1 0 0 1 0-7.2 5.1 5.1 0 0 1 7.2 0l.9.9.9-.9a5.1 5.1 0 0 1 7.2 0 5.1 5.1 0 0 1 0 7.2Z"/></svg>';

  class DkyLike extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = '1';

      this.handle = this.dataset.handle;
      this.compact = this.hasAttribute('data-compact');

      this.innerHTML =
        '<button type="button" class="dky-like__btn" aria-pressed="false">' +
        HEART +
        '<span class="dky-like__count"' +
        (this.compact ? '' : '') +
        '></span>' +
        '</button>';

      this.button = this.querySelector('button');
      this.countEl = this.querySelector('.dky-like__count');

      this.button.addEventListener('click', (event) => {
        // Kartu produk dibungkus link - jangan sampai ikut pindah halaman.
        event.preventDefault();
        event.stopPropagation();
        this.toggle();
      });

      DkyLike.queue.push(this);
      DkyLike.scheduleFetch();
    }

    /** Dipakai kartu homepage yang produknya berganti lewat panah < >. */
    setHandle(handle) {
      if (!handle || handle === this.handle) return;
      this.handle = handle;
      this.dataset.handle = handle;
      this.render(null, false);
      DkyLike.queue.push(this);
      DkyLike.scheduleFetch();
    }

    render(count, liked) {
      if (typeof count === 'number') {
        this.count = count;
        this.countEl.textContent = count > 0 ? count : '';
      }
      if (typeof liked === 'boolean') {
        this.liked = liked;
        this.button.setAttribute('aria-pressed', liked ? 'true' : 'false');
        this.classList.toggle('is-liked', liked);
      }
      this.button.setAttribute('aria-label', this.liked ? 'Unlike' : 'Like');
    }

    toggle() {
      if (this.busy) return;
      this.busy = true;

      const wasLiked = this.liked;
      const nextCount = Math.max(0, (this.count || 0) + (wasLiked ? -1 : 1));

      // Tampilan langsung berubah supaya terasa cepat; dikembalikan kalau gagal.
      this.render(nextCount, !wasLiked);
      this.classList.add('is-pulsing');
      setTimeout(() => this.classList.remove('is-pulsing'), 400);

      /* Wishlist mengikuti status hati DUA ARAH.

         Sebelumnya melepas love sengaja tidak menyentuh wishlist. Akibatnya
         melepas love tidak memberi tanda apa pun, dan me-love ulang juga
         diam - handle-nya tidak pernah keluar dari daftar, jadi penambahan
         berikutnya dianggap tidak mengubah apa-apa. */
      if (wasLiked) removeFromWishlist(this.handle);
      else addToWishlist(this.handle);

      post(wasLiked ? '/unlike' : '/like', { handle: this.handle, visitor: visitorId() })
        .then((data) => {
          if (data && typeof data.count === 'number') this.render(data.count, !wasLiked);
        })
        .catch(() => {
          this.render(this.count + (wasLiked ? 1 : -1), wasLiked); // batal
        })
        .then(() => {
          this.busy = false;
        });
    }
  }

  /* Semua hati di satu halaman ditanya ke server dalam SATU permintaan. */
  DkyLike.queue = [];
  DkyLike.timer = null;

  DkyLike.scheduleFetch = function () {
    clearTimeout(DkyLike.timer);
    DkyLike.timer = setTimeout(DkyLike.fetchCounts, 60);
  };

  DkyLike.fetchCounts = function () {
    const items = DkyLike.queue.splice(0);
    if (items.length === 0) return;

    const handles = [];
    for (const item of items) {
      if (item.handle && !handles.includes(item.handle)) handles.push(item.handle);
    }
    if (handles.length === 0) return;

    const url =
      API + '/counts?handles=' + encodeURIComponent(handles.join(',')) + '&visitor=' + encodeURIComponent(visitorId());

    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        for (const item of items) {
          const count = (data.counts && data.counts[item.handle]) || 0;
          item.render(count, data.liked ? data.liked.indexOf(item.handle) !== -1 : false);
        }
      })
      .catch(() => {
        for (const item of items) item.render(0, false);
      });
  };

  if (!customElements.get('dky-like')) customElements.define('dky-like', DkyLike);

  /* ---------- angka kecil di ikon hati header ---------- */

  class DkyWishlistCount extends HTMLElement {
    connectedCallback() {
      this.update();
      document.addEventListener('dky:wishlist-change', () => this.update());
    }

    update() {
      const total = getWishlist().length;
      this.textContent = total > 0 ? total : '';
      this.classList.toggle('is-visible', total > 0);

    }
  }

  if (!customElements.get('dky-wishlist-count')) customElements.define('dky-wishlist-count', DkyWishlistCount);

  /* ---------- alat bantu untuk halaman lain ---------- */

  /* ------------------------------------------------------------------
     PEMASANGAN OTOMATIS di kartu produk buatan section lain.

     Kenapa ada: section homepage (dky-grid-geser) dikerjakan orang lain yang
     memakai alat berbeda. Setiap kali file section itu ditimpa versi mereka,
     tombol hati yang disisipkan lewat Liquid ikut terhapus — itu benar-benar
     terjadi 26 Agu 2026.

     Jadi hatinya tidak lagi bergantung pada file mereka: kode ini mencari
     kartu produk yang belum punya hati, lalu memasangnya sendiri. Kalau
     kartunya SUDAH punya hati dari Liquid, kartu itu dilewati - tidak dobel.
     ------------------------------------------------------------------ */

  const KARTU_LUAR = ['.dky-gg__box', '.dky-gg__tile', '.dky-unggulan__card'];

  function handleDariUrl(url) {
    const cocok = String(url || '').match(/\/products\/([a-z0-9][a-z0-9-]*)/i);
    return cocok ? cocok[1].toLowerCase() : null;
  }

  function pasangOtomatis() {
    for (const pemilih of KARTU_LUAR) {
      for (const kartu of document.querySelectorAll(pemilih)) {
        if (kartu.querySelector('dky-like')) continue; // sudah ada, lewati

        const tautan = kartu.matches('a[href]') ? kartu : kartu.querySelector('a[href*="/products/"]');
        const handle = handleDariUrl(tautan && tautan.getAttribute('href'));
        if (!handle) continue;

        const hati = document.createElement('dky-like');
        hati.className = 'dky-gg__like';
        hati.dataset.handle = handle;
        hati.setAttribute('data-compact', '');

        // Induk harus punya posisi supaya hatinya bisa menempel di pojok.
        if (getComputedStyle(kartu).position === 'static') kartu.style.position = 'relative';
        kartu.appendChild(hati);
      }
    }
  }

  pasangOtomatis();

  // Section bisa dimuat ulang saat diedit di Theme Editor, dan slider bisa
  // menambah kartu belakangan. Amati perubahan halaman secukupnya.
  document.addEventListener('shopify:section:load', pasangOtomatis);

  let jadwal = null;
  new MutationObserver(() => {
    clearTimeout(jadwal);
    jadwal = setTimeout(pasangOtomatis, 300);
  }).observe(document.body, { childList: true, subtree: true });

  window.DkyWishlist = {
    get: getWishlist,
    add: addToWishlist,
    remove: removeFromWishlist,
    count: function () {
      return getWishlist().length;
    },
  };

  syncWishlist();
})();

/* ------------------------------------------------------------------
   dky gulir foto: penerus guliran saat galeri produk mentok.

   Galeri foto punya area gulir sendiri (dky-produk.css). Masalahnya browser
   "mengunci" roda mouse ke area itu — setelah foto mentok, halaman tidak
   ikut bergerak sampai kursor digeser (keluhan Nandha 30 Agu 2026).
   Di sini: begitu galeri mentok atas/bawah, guliran langsung dioper ke
   halaman tanpa menunggu kunci browser lepas.
   ------------------------------------------------------------------ */
(function () {
  document.addEventListener(
    'wheel',
    function (event) {
      const galeri = event.target.closest && event.target.closest('.product-gallery');
      if (!galeri) return;

      const bisaGulir = galeri.scrollHeight > galeri.clientHeight + 2;
      if (!bisaGulir) return;

      const diBawah = galeri.scrollTop + galeri.clientHeight >= galeri.scrollHeight - 2;
      const diAtas = galeri.scrollTop <= 1;

      if ((event.deltaY > 0 && diBawah) || (event.deltaY < 0 && diAtas)) {
        event.preventDefault();
        window.scrollBy({ top: event.deltaY });
      }
    },
    { passive: false }
  );
})();

/* ------------------------------------------------------------------
   dky deteksi transparan: menandai foto produk yang berlatar tembus pandang.

   Bayangan produk (drop-shadow) hanya masuk akal untuk foto transparan —
   pada foto padat, bayangannya jadi kotak mengelilingi seluruh gambar.
   Dulu penyaringnya daftar nama berkas, sehingga SETIAP koleksi baru harus
   didaftarkan manual (keluhan Nandha 1 Sep 2026). Sekarang diperiksa sendiri:
   versi 24px dari foto diambil, empat pojoknya dilihat; kalau keempatnya
   tembus pandang, foto itu diberi kelas .dky-transparan.

   Hasil pemeriksaan disimpan di sessionStorage supaya foto yang sama tidak
   diperiksa berulang saat pindah halaman.
   ------------------------------------------------------------------ */
(function () {
  /* localStorage, BUKAN sessionStorage (diubah 2 Okt 2026).

     sessionStorage mati begitu tab ditutup, jadi pengunjung yang kembali
     besok memeriksa ulang SELURUH katalog dari nol. Hasil pemeriksaan ini
     sifatnya tetap - sebuah foto transparan hari ini tetap transparan
     besok - jadi tidak ada alasan membuangnya tiap sesi. Berkas ini sudah
     memakai localStorage di tempat lain (lihat safeGet/safeSet di atas).

     Versi kunci dinaikkan ke v2 supaya catatan lama di sessionStorage
     tidak ikut terbaca separuh-separuh. */
  const KUNCI = 'dky_transparan_v2';
  let ingatan = {};
  try {
    ingatan = JSON.parse(localStorage.getItem(KUNCI) || '{}');
  } catch (e) {
    /* abaikan */
  }

  function simpan() {
    try {
      localStorage.setItem(KUNCI, JSON.stringify(ingatan));
    } catch (e) {
      /* abaikan - mode penyamaran atau kuota penuh */
    }
  }

  /** Alamat foto tanpa parameter ukuran — supaya satu foto = satu catatan. */
  function pokok(src) {
    return (src || '').split('?')[0];
  }

  /* ------------------------------------------------------------------
     ANTREAN: yang sudah diketahui dipakai SEKETIKA, yang belum MENUNGGU.

     Dulu setiap foto yang belum dikenal langsung menarik versi 24px-nya
     saat halaman dibaca. Diukur di /collections/all-cats pada viewport HP
     sungguhan (CDP 390x844 DPR 3, 2 Okt 2026): **48 permintaan `?width=24`,
     109 KB**. Byte-nya kecil, tapi 48 perjalanan jaringan tidak - di
     seluler tiap perjalanan punya biaya sendiri, dan semuanya berebut
     jalur dengan foto produk yang justru sedang dilihat.

     Hampir semuanya sia-sia: di layar 390x844 hanya sekitar empat kartu
     terlihat. Sisanya diperiksa untuk kartu yang mungkin tak pernah
     digulir.

     Sekarang hanya foto yang MENDEKATI layar yang diperiksa. rootMargin
     600px menjaga niat asli komentar di bawah: bayangannya sudah terpasang
     sebelum fotonya sempat terlihat pembeli, bukan muncul mendadak.

     Yang sudah ada di ingatan TIDAK ikut menunggu - kelasnya dipasang
     seketika, jadi pengunjung yang kembali tidak melihat kedipan apa pun.
     ------------------------------------------------------------------ */
  let pengamat = null;

  function antre(img) {
    if (typeof IntersectionObserver !== 'function') {
      ukur(img);
      return;
    }
    if (!pengamat) {
      pengamat = new IntersectionObserver(
        function (masuk) {
          for (const e of masuk) {
            if (!e.isIntersecting) continue;
            pengamat.unobserve(e.target);
            ukur(e.target);
          }
        },
        { rootMargin: '600px 0px' }
      );
    }
    pengamat.observe(img);
  }

  function periksa(img) {
    /* Pakai atribut src, BUKAN currentSrc: foto yang dimuat malas (lazy)
       belum punya currentSrc sampai ia masuk layar, padahal alamatnya sudah
       diketahui sejak awal. Dengan begini bayangan sudah terpasang sebelum
       fotonya sempat terlihat pembeli. */
    const src = pokok(img.getAttribute('src') || img.currentSrc || img.src);
    if (!src || !src.includes('/cdn/shop/')) return;

    if (ingatan[src] === true) return img.classList.add('dky-transparan');
    if (ingatan[src] === false) return;

    antre(img);
  }

  function ukur(img) {
    const src = pokok(img.getAttribute('src') || img.currentSrc || img.src);
    if (!src || !src.includes('/cdn/shop/')) return;
    if (ingatan[src] === true) return img.classList.add('dky-transparan');
    if (ingatan[src] === false) return;

    const kecil = new Image();
    kecil.crossOrigin = 'anonymous';
    kecil.onload = function () {
      let transparan = false;
      try {
        const c = document.createElement('canvas');
        c.width = kecil.width;
        c.height = kecil.height;
        const ctx = c.getContext('2d');
        ctx.drawImage(kecil, 0, 0);
        const d = ctx.getImageData(0, 0, c.width, c.height).data;
        const pojok = [
          0,
          (c.width - 1) * 4,
          (c.height - 1) * c.width * 4,
          (c.height * c.width - 1) * 4,
        ];
        transparan = pojok.every((i) => d[i + 3] < 16);
      } catch (e) {
        transparan = false; // izin baca piksel ditolak - anggap padat
      }

      ingatan[src] = transparan;
      simpan();
      if (transparan) img.classList.add('dky-transparan');
    };
    kecil.onerror = function () {
      ingatan[src] = false;
      simpan();
    };
    kecil.src = src + '?width=24';
  }

  function sapu() {
    const pilih = [
      '.product-gallery__media img',
      '.product-card__image',
      '.dky-gg__media img',
      '.dky-gg__mitem img',
    ].join(',');
    for (const img of document.querySelectorAll(pilih)) {
      if (img.dataset.dkyCek) continue;
      img.dataset.dkyCek = '1';
      periksa(img); // tidak perlu menunggu foto termuat
    }
  }

  sapu();
  document.addEventListener('shopify:section:load', sapu);

  let jadwal = null;
  new MutationObserver(() => {
    clearTimeout(jadwal);
    jadwal = setTimeout(sapu, 300);
  }).observe(document.body, { childList: true, subtree: true });
})();
